import { NoCompaniesPage } from './NoCompaniesPage';
import { withNoCompanies } from './withNoCompaniesPage';

const ConnectedNoCompaniesPage = withNoCompanies(NoCompaniesPage);

export { ConnectedNoCompaniesPage as NoCompaniesPage };
